import React, { useState, useEffect } from "react";

const Form = ({
    tagToEdit = null,
    onFormSubmit,
    onCancelHandler
}) => {
    const [form, setForm] = useState({
        uid: null,
        name: "",
    });

    const TAG_MAX_LENGTH = 25;

    useEffect(() => {
        if (tagToEdit) {
            setForm({
                uid: tagToEdit.uid,
                name: tagToEdit.name,
            });
        }
    }, [tagToEdit]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prevForm => ({
            ...prevForm,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await onFormSubmit({ ...form });
        } catch (error) {
            console.error('Failed to save tag:', error);
        }
    };

    const handleCancel = () => {
        setForm({
            uid: null,
            name: "",
        });

        onCancelHandler();
    };

    return (
        <div className="card container-height">
            <form id="tagsForm" className="d-flex flex-column h-100" onSubmit={handleSubmit}>
                <div className="card-header form-card-header-paddings no-background no-border">
                    <div className="p-2">
                        <h3>{form.uid ? 'Edit Tag' : 'New Tag'}</h3>
                    </div>
                </div>

                <div className="card-body form-card-body-paddings overflow-auto">
                    <div className="mb-3">
                        <div className="d-flex justify-content-between">
                            <label htmlFor="tagName" className="form-label">Tag</label>
                            <small className="text-muted">
                                {form.name.length}/{TAG_MAX_LENGTH}
                            </small>
                        </div>
                        <input
                            type="text"
                            id="tagName"
                            name="name"
                            value={form.name}
                            onChange={handleInputChange}
                            className="form-control"
                            maxLength={TAG_MAX_LENGTH}
                            required
                        />
                    </div>
                </div>

                <div className="card-footer form-card-footer-paddings border-top no-background">
                    <div className="d-flex justify-content-between">
                        <button
                            type="submit"
                            className="btn btn-success"
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmit(e);
                            }}
                        >
                            {form.uid ? 'Save' : 'Add'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Form;
